<template>
    <div class="feedback-wrap">
        <bread-crumb :bread-list="breadList" />
        <div class="feedback-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">反馈统计</span>
            </div>
            <div class="search-wrap">
                <div class="list-tab-wrap">
                    <div class="list-tab-item"
                            :class="[{'is-choosed': timeTab=='month'}]"
                            @click="changeTab('month')">
                        <span class="text">近30日</span>
                    </div>
                    <div class="list-tab-item last-tab-item"
                            :class="[{'is-choosed': timeTab=='week'}]"
                            @click="changeTab('week')">
                        <span class="text">近7日</span>
                    </div>
                    <el-date-picker size="small"
                                    :class="[{'choosed-select': isDateChoosed}]"
                                    :clearable="false"
                                    v-model="selectForm.followTime"
                                    type="daterange"
                                    range-separator="-"
                                    start-placeholder="yyyy-mm-dd"
                                    end-placeholder="yyyy-mm-dd"
                                    value-format="yyyy-MM-dd"
                                    :style="{width: '240px', height: '34px'}"
                                    @change="handleFollowDateChange"
                                    :picker-options="datePickerOptions"></el-date-picker>
                </div>
                <el-button size="small"
                           @click="getExcelData()">导出Excel</el-button>
            </div>

            <div class="table-wrap">
                <el-table :data="dataList"
                          stripe
                          v-loading="loading"
                          style="width: 100%">
                    <el-table-column
                        width="70px"
                        label="序号"
                        type="index">
                    </el-table-column>
                    <el-table-column width="168px"
                                     label="提交反馈时间">
                        <template slot-scope="scope">
                            {{scope.row.suggestTime}}
                        </template>
                    </el-table-column>

                    <el-table-column width="120px"
                                     label="姓名">
                        <template slot-scope="scope">
                            {{scope.row.name}}
                        </template>
                    </el-table-column>

                    <el-table-column label="手机号"
                                     width="140px">
                        <template slot-scope="scope">
                            {{scope.row.phone}}
                        </template>
                    </el-table-column>

                    <el-table-column label="反馈内容">
                        <template slot-scope="scope">
                            {{scope.row.content}}
                        </template>
                    </el-table-column>
                    <el-table-column label="处理意见">
                        <template slot-scope="scope">
                            {{scope.row.answer?scope.row.answer:'-'}}
                        </template>
                    </el-table-column>

                    <el-table-column label="操作"
                                     width="140px">
                        <template slot-scope="scope">
                            <span @click="handleFeedback(scope.row)"
                                  v-if="!scope.row.answer"
                                  class="link-btn">处理</span>
                            <span v-else
                                  class="link-btn link-text">已处理</span>
                        </template>
                    </el-table-column>

                    <div slot="empty"
                         class="table-none">
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="pageChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="回复内容"
                   :visible.sync="isEditShow"
                   custom-class="feedback-dialog"
                   :destroy-on-close="true"
                   @close="closeDialog()"
                   width="400px">
            <el-form :model="groupForm"
                     label-width="80px"
                     ref="groupForm">
                <el-form-item label="处理意见"
                              :rules="[{ required: true, message: '请输入处理意见'}]"
                              prop="answer">
                    <el-input v-model.trim="groupForm.answer"
                              type="textarea"
                              placeholder="请输入处理意见"
                              resize="none"
                              :rows="7"
                              show-word-limit
                              :style="{width: '290px',height: '160px'}"
                              maxlength="150"></el-input>
                </el-form-item>
                <div class="dialog-btn-wrap">
                    <el-button size="small"
                               type="primary"
                               @click="putDetailFeed()">提 交</el-button>
                    <el-button size="small"
                               type="info"
                               plain
                               @click="cancelForm()">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { dateToString } from '@/utils/tools.js'
import shortcuts from '@/utils/pickerOptions.js'
import { mapGetters } from 'vuex'
export default {
    name: 'registerList',
    data () {
        return {
            timeTab: 'month',
            isDateChoosed: false,
            selectForm: {
                endTime: '',
                startTime: '',
                followTime: []
            },
            followTime: '',
            loading: false,
            datePickerOptions: {
                disabledDate (time) {
                    return time.getTime() > Date.now() - 8.64e6
                },
                shortcuts: shortcuts
            },
            breadList: [{ label: '用户管理' }, { label: '反馈统计' }],
            dataList: [],
            iuid: '',
            page: {
                current: 1,
                total: 1,
                pageSize: 10
            },
            groupForm: {
                suggestId: '',
                answer: ''
            },
            isEditShow: false
        }
    },
    computed: {
        ...mapGetters([
            'userInfo'
        ])
    },
    methods: {
        // 导出列表数据
        formatWayJson (filterVal, jsonData) {
            return jsonData.map((v, index) => {
                return filterVal.map((j) => {
                    if (j === 'index') {
                        return (index + 1)
                    } else if (j === 'suggestTime') {
                        if (v.suggestTime) {
                            return v.suggestTime
                        } else {
                            return '-'
                        }
                    } else if (j === 'name') {
                        if (v.name) {
                            return v.name
                        } else {
                            return '-'
                        }
                    } else if (j === 'phone') {
                        if (v.phone) {
                            return v.phone
                        } else {
                            return '-'
                        }
                    } else if (j === 'content') {
                        if (v.content) {
                            return v.content
                        } else {
                            return '-'
                        }
                    } else if (j === 'answer') {
                        if (v.answer) {
                            return v.answer
                        } else {
                            return '-'
                        }
                    } else {
                        return v[j]
                    }
                })
            })
        },
        getExcel () {
            import('@/vendor/Export2Excel').then(excel => {
                const tHeader = ['序号', '提交反馈时间', '姓名', '手机号', '文本答案', '处理意见']
                const filterVal = ['index', 'suggestTime', 'name', 'phone', 'content', 'answer']
                const list = this.dataList
                if (list.length > 0) {
                    const data = this.formatWayJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '反馈列表',
                        autoWidth: true,
                        bookType: 'xlsx'
                    })
                } else {
                    this.$message({
                        message: '无数据导出！',
                        type: 'warning',
                        center: true
                    })
                }
            })
        },
        getExcelData () {
            this.page.pageSize = 1000000
            this.page.current = 1
            this.queryList(this.getExcel)
        },
        changeTab (type) {
            this.timeTab = type
            this.isDateChoosed = false
            this.selectForm.endTime = ''
            this.selectForm.startTime = ''
            this.selectForm.followTime = []
            if (type === 'week') {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                this.selectForm.startTime = dateToString(start, 'yyyy-MM-dd') + ' 00:00:00'
                this.selectForm.endTime = dateToString(end, 'yyyy-MM-dd') + ' 23:59:59'
                this.selectForm.followTime = [start, end]
            } else if (type === 'month') {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
                this.selectForm.startTime = dateToString(start, 'yyyy-MM-dd') + ' 00:00:00'
                this.selectForm.endTime = dateToString(end, 'yyyy-MM-dd') + ' 23:59:59'
                this.selectForm.followTime = [start, end]
            }
            this.page.current = 1
            this.queryList()
        },
        handleFollowDateChange (value) {
            if (value) {
                this.selectForm.startTime = value[0] + ' 00:00:00'
                this.selectForm.endTime = value[1] + ' 23:59:59'
            } else {
                this.selectForm.startTime = ''
                this.selectForm.endTime = ''
            }
            this.page.current = 1
            this.queryList()
        },
        closeDialog () {
            const obj = this.dataList.find(d => d.suggestId === this.groupForm.suggestId)
            if (obj) {
                obj.tempAnswer = this.groupForm.answer
            }
            this.groupForm.answer = ''
        },
        handleFeedback (value) {
            this.isEditShow = true
            this.$nextTick(() => {
                this.$refs['groupForm'].clearValidate()
            })
            this.groupForm.suggestId = value.suggestId
            this.groupForm.answer = value.tempAnswer
        },
        cancelForm () {
            this.isEditShow = false
        },
        // 处理put提交
        async putDetailFeed () {
            if (!this.groupForm.answer) {
                this.$message.warning('处理意见不能为空')
                return
            }
            this.isEditShow = false
            this.loading = true
            let param = {
                iuid: this.userInfo.iuid,
                hospitalId: this.userInfo.hospitalId,
                suggestId: this.groupForm.suggestId,
                answer: this.groupForm.answer
            }
            const { results, state } = await this.$services.feedbackServices.answerFeedback(param)
            if (results && state === 200) {
                this.$message.success('处理意见提交成功')
                this.groupForm.answer = ''
                this.groupForm.suggestId = ''
                this.queryList()
            } else {
                this.$message.error('处理意见提交失败，请稍后重试')
                this.loading = false
            }
        },
        pageChange (value) {
            this.page.current = value
            this.queryList()
        },
        async queryList (func) {
            if (!func) {
                this.page.pageSize = 15
                this.loading = true
            }
            const param = {
                current: this.page.current,
                size: this.page.pageSize,
                createTimeStart: this.selectForm.startTime,
                createTimeEnd: this.selectForm.endTime,
                hospitalId: this.userInfo.hospitalId
            }
            console.log(this.$services.feedbackServices)
            const { results, total } = await this.$services.feedbackServices.getFeedbackList(param)
            results.forEach(item => {
                item.tempAnswer = item.answer ? item.answer : ''
            })
            this.dataList = results
            if (func) {
                func(this.dataList)
            }
            this.page.total = total
            this.loading = false
        }
    },
    mounted () {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
        this.selectForm.startTime = dateToString(start, 'yyyy-MM-dd') + ' 00:00:00'
        this.selectForm.endTime = dateToString(end, 'yyyy-MM-dd') + ' 23:59:59'
        this.selectForm.followTime = [start, end]
        this.queryList()
    }
}
</script>
<style lang="scss">
.feedback-dialog {
    .el-textarea .el-input__count {
        line-height: 24px;
    }
    .el-dialog__body {
        padding: 24px 0px;
        display: flex;
        justify-content: center;
    }
    .el-form-item {
        margin-bottom: 24px;
        &.is-error {
            margin-bottom: 30px;
        }
    }
    .dialog-btn-wrap {
        padding: 0 20px 0px 80px;
        text-align: left;
        .el-button {
            width: 96px;
            font-size: 14px;
        }
        .el-button--info.is-plain {
            margin-left: 12px;
            background-color: #f5f5f5;
            border-color: #dbdbdb;
            color: #666;
        }
    }
}
.feedback-wrap {
    .el-date-editor {
        vertical-align: middle;
        margin-left: 20px;
    }
}
</style>
<style lang="scss" scoped>
.feedback-wrap {
    height: calc(100% - 70px);
}
.feedback-content {
    height: 100%;
    box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
    margin: 20px;
    padding: 0;
    background: #fff;
    overflow: auto;
}
.search-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px 20px;
}
.list-tab-wrap {
    font-size: 0;
}

.list-tab-item {
    display: inline-block;
    width: 98px;
    text-align: center;
    height: 34px;
    border: 1px solid #e8e8e8;
    box-sizing: border-box;
    line-height: 34px;
    font-size: 0;
    color: #333333;
    cursor: pointer;
    background-color: #fff;
    vertical-align: middle;
    border-right: none;
    &:first-child {
        border-left: 1px solid #e8e8e8;
        border-radius: 3px 0 0 3px;
    }

    &:last-child {
        border-radius: 0 3px 3px 0;
    }

    .text {
        font-size: 14px;
    }

    .number {
        margin-left: 8px;
        font-size: 14px;
    }
}
.last-tab-item {
    border-radius: 0 3px 3px 0;
    border-right: 1px solid #e8e8e8;
}
.list-tab-item.is-choosed {
    border-color: $color-primary;
    background: #fff;
    color: $color-primary;
    & + .list-tab-item {
        border-left-color: $color-primary;
    }
}
.title-wrap {
    margin: 20px;
    height: 16px;
    line-height: 16px;
    .icon-tongyongbiaotiicon {
        color: $color-primary;
        font-size: 16px;
        vertical-align: middle;
    }
    .title-text {
        font-size: 14px;
        color: #333333;
        margin-left: 10px;
        display: inline-block;
        height: 16px;
        line-height: 16px;
        vertical-align: middle;
    }
}
.table-wrap {
    padding: 0 20px;
    .table-none {
        height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .icon {
            font-size: 100px;
        }
        span {
            line-height: 14px;
        }
    }
    .link-btn {
        color: $a-link;
        cursor: pointer;
        font-size: 12px;
        display: inline-block;
        height: 14px;
        line-height: 14px;
        border-right: 1px solid $a-link;
        margin-right: 6px;
        padding-right: 6px;
        &:last-child {
            border-right: none;
            margin-right: 0;
            padding-right: 0;
        }
    }
    .link-text {
        color: #ccc;
        cursor: not-allowed;
    }
}
.pagination-wrap {
    padding: 0 20px;
}

</style>
